import React, { useState } from 'react'
import ScrollLock, { TouchScrollable } from 'react-scrolllock'

import scrollTo from 'gatsby-plugin-smoothscroll'

import Brand from '../Brand'
import Toggle from '../Toggle'
import menu from './menu'
import * as S from './styled'

const Header = () => {
  const [opened, setOpened] = useState(false)

  return (
    <>
      <ScrollLock isActive={opened} />
      <S.HeaderWrapper className="border-texture-bottom">
        <S.HeaderContainer>
          <Brand
            onClick={() => {
              scrollTo('#inicio')
              setOpened(false)
            }}
          />
          <Toggle opened={opened} handleOpened={() => setOpened(!opened)} />
        </S.HeaderContainer>
      </S.HeaderWrapper>

      <S.HeaderMenu opened={opened} className="texture-light">
        <TouchScrollable>
          <S.HeaderMenuList>
            {menu.map(({ to, label }, i) => (
              <S.HeaderMenuItem key={i}>
                <S.HeaderMenuLink
                  onClick={() => {
                    scrollTo(to)
                    setOpened(false)
                  }}
                  title={label}
                >
                  {label}
                </S.HeaderMenuLink>
              </S.HeaderMenuItem>
            ))}
          </S.HeaderMenuList>
        </TouchScrollable>
      </S.HeaderMenu>
    </>
  )
}
export default Header
